module.exports = __webpack_public_path__ + "img/icon_news.219648a.webp";